import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, saveTaxaServico } from './types';

export const INITIAL_STATE: saveTaxaServico = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): saveTaxaServico {
	return produce(state, draft => {
		switch (action.type) {
			case Types.SAVE_TAXA_SERVICO: {
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.SAVE_TAXA_SERVICO_SUCCESS: {
				draft.data = action.payload;
				draft.status = 200;
				break;
			}

			case Types.SAVE_TAXA_SERVICO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.SAVE_TAXA_SERVICO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
